import { ChangeDetectionStrategy, Component, ContentChild, Input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { NoDataComponent, NoDataSubtitleDirective, NoDataTitleDirective } from '../no-data';

import { NoTableDataSubtitleDirective, NoTableDataTitleDirective } from './no-table-data.directives';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tr[woNoTableData]',
  templateUrl: './no-table-data.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    class: 'iss-row',
  },
  standalone: true,
  imports: [ NgTemplateOutlet, NoDataComponent, NoDataTitleDirective, NoDataSubtitleDirective ],
})
export class NoTableDataComponent {
  @ContentChild(NoTableDataTitleDirective, { static: false }) title?: NoTableDataTitleDirective;
  @ContentChild(NoTableDataSubtitleDirective, { static: false }) subtitle?: NoTableDataSubtitleDirective;
  @Input() public height = '435px'; // to avoid layout shifting: loading state has 10 rows x 45px + 1px border between rows -12px padding top and bottom.
}
